import { cn } from '@/lib/cn';
import type { CanonStatus, Confidence } from '@/types/entity';

const STATUS: Record<CanonStatus, { label: string; cls: string }> = {
  canon: { label: 'CANON', cls: 'border-star/50 text-star' },
  draft: { label: 'DRAFT', cls: 'border-dashed border-line-2 text-faint' },
  deprecated: { label: '폐기', cls: 'border-line text-fainter line-through' },
  question: { label: '미결정', cls: 'border-ember/50 text-ember' },
  alternate: { label: '대안', cls: 'border-star-2/50 text-star-2' },
};

const CONF_DOTS: Record<Confidence, string> = {
  confirmed: '●●●',
  probable: '●●○',
  speculative: '●○○',
};

export function CanonBadge({
  canonStatus,
  confidence,
  className,
  showConfidence = false,
}: {
  canonStatus: CanonStatus;
  confidence?: Confidence;
  className?: string;
  showConfidence?: boolean;
}) {
  const s = STATUS[canonStatus];
  return (
    <span className={cn('inline-flex items-center gap-1.5', className)}>
      <span
        className={cn(
          'rounded-sm border px-1.5 py-px font-mono text-[10px] uppercase tracking-[0.12em]',
          s.cls,
        )}
      >
        {s.label}
      </span>
      {showConfidence && confidence && (
        <span
          className="font-mono text-[10px] tracking-[0.1em] text-fainter"
          title={`확신도: ${confidence}`}
        >
          {CONF_DOTS[confidence]}
        </span>
      )}
    </span>
  );
}
